import React from "react"
import { Helmet } from "react-helmet"

import HowToGetLicense from "../template-parts/HowToGetLicense"
import Section from "../template-parts/product-marketing/Section"

const HowToGetLicensePage = () => (
  <>
    <Helmet>
      <title>How to get a Driver License in Your State</title>
      <link
        rel="canonical"
        href="https://coastlineacademy.com/how-to-get-drivers-license"
      />
    </Helmet>
    <Section
      head="How to get a Driver License in Your State"
      subhead="Follow our step-by-step guide to earning your license."
      useH1={true}
    >
      <HowToGetLicense controlsToShow={["state", "path"]} />
    </Section>
  </>
)

export default HowToGetLicensePage
